<template>
    <Dialog v-model:open="opened">
        <DialogTrigger> <slot /> </DialogTrigger>
        <DialogContent
            class="sm:max-h-[calc(100dvh-8rem)] flex max-h-[calc(100dvh-2rem)] flex-col"
        >
            <DialogHeader>
                <DialogTitle>
                    <span v-if="availabilityId">
                        {{ $t("availability.edit_availability.title") }}
                    </span>
                    <span v-else>
                        {{ $t("availability.create_availability.title") }}
                    </span>
                </DialogTitle>

                <template #icon>
                    <Clock class="h-5 w-5 text-z-primary-600" />
                </template>
            </DialogHeader>

            <div class="px-6 flex-1 overflow-y-auto">
                <ManageAvailability
                    :availability-id="availabilityId"
                    :availability-name="availabilityName"
                    :days="days"
                    @on-finish="onFinish"
                >
                    <template
                        #create-button="{ createAvailability, isValid, hasId }"
                    >
                        <DialogFooter
                            v-if="!hasId"
                            class="mt-10 px-0 sm:justify-between"
                        >
                            <DialogClose>
                                <Button variant="outline">
                                    {{ $t("cancel") }}
                                </Button>
                            </DialogClose>
                            <ZButton
                                :disabled="!isValid"
                                class="ml-4 disabled:cursor-not-allowed disabled:opacity-50"
                                type="button"
                                @click="createAvailability"
                                >{{
                                    $t("availability.create_availability.title")
                                }}</ZButton
                            >
                        </DialogFooter>
                    </template>

                    <template
                        #edit-button="{ updateAvailability, isValid, hasId }"
                    >
                        <DialogFooter
                            v-if="hasId"
                            class="mt-10 px-0 sm:justify-between"
                        >
                            <DialogClose>
                                <Button variant="outline">
                                    {{ $t("cancel") }}
                                </Button>
                            </DialogClose>

                            <ZButton
                                :disabled="!isValid"
                                class="ml-4 disabled:cursor-not-allowed disabled:opacity-50"
                                type="button"
                                @click="updateAvailability"
                                >{{
                                    $t("availability.edit_availability.title")
                                }}</ZButton
                            >
                        </DialogFooter>
                    </template>
                </ManageAvailability>
            </div>
        </DialogContent>
    </Dialog>
</template>

<script setup lang="ts">
import ManageAvailability from "./ManageAvailability.vue";
import ZButton from "../../Atomic/Button.vue";

import { Button } from "@/components/ui/button";

import {
    Dialog,
    DialogContent,
    DialogFooter,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
    DialogClose,
} from "@/components/ui/dialog-v2";

import { ref } from "vue";
import { Clock } from "lucide-vue-next";

const opened = ref(false);

const emit = defineEmits(["on-finish"]);
function onFinish({ created }: { created: boolean }) {
    emit("on-finish", { created });
    opened.value = false;
}

defineProps({
    availabilityId: {
        type: Number,
        required: false,
    },
    availabilityName: {
        type: String,
        required: false,
    },
    days: {
        type: Object,
        required: false,
    },
});
</script>

<style>
.v-enter-active,
.v-leave-active {
    transition: all 200ms ease-in;
    transform: translateY(0);
}

.v-enter-from,
.v-leave-to {
    transform: translateY(-2px);

    opacity: 0;
}
</style>
